<div class="logout-container">
  <div class="logout-title">آیا می‌خواهید از حساب کاربری خود خارج شوید؟</div>
  <mat-divider></mat-divider>
  <div class="button-holder">
    <div class="right-button" (click)="onRejectAction()">خیر</div>
    <div class="left-button" (click)="onAcceptAction()">بله</div>
  </div>
</div>
